// extracted by mini-css-extract-plugin
export default {"button":"Admin_button__bLzxZ"};